// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import { Link, useNavigate } from "react-router-dom";
// import baseURL from "./baseURL/BaseURL";
// import sideImage from "../../assets/images/signup.jpeg";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const SignUpScreen = () => {
//   const navigate = useNavigate();
//   const [countries, setCountries] = useState([]);
//   const [divisions, setDivisions] = useState([]);
//   const [cities, setCities] = useState([]);
//   const [formData, setFormData] = useState({
//     first_name: "",
//     last_name: "",
//     email: "",
//     gender: "",
//     occupation: "",
//     income: "",
//     password: "",
//     password_confirmation: "",
//     title: "",
//     show_name: "",
//     feet: "",
//     inch: "",
//     marital_status: "",
//     caste: "",
//     look: "",
//     education: "",
//     religion: "",
//     whatsapp: "",
//     mobile: "",
//     you_are: "",
//     world_country_id: "",
//     world_division_id: "",
//     world_city_id: "",
//     dob: "",
//     age: "",
//     image: null,
//   });

//   const enumData = {
//     show_name: { show_yes: "Yes", show_no: "No" },
//     gender: { male: "Male", female: "Female" },
//     marital_status: {
//       single: "Single",
//       widow: "Widow (Husband Died)",
//       widower: "Widower (Wife Died)",
//       divorced: "Divorced",
//       separated: "Separated",
//     },
//     look: {
//       very_fair: "Very Fair",
//       fair: "Fair",
//       medium: "Medium",
//       dark: "Dark",
//     },
//     education: {
//       under_matric: "Under Matric",
//       matric: "Matric",
//       intermediate: "Intermediate",
//       graduation: "Graduation",
//       masters: "Masters",
//       phd: "PHD",
//     },
//     occupation: {
//       doctor: "Doctor",
//       engineer: "Engineer",
//       css_officer: "CSS Officer",
//       cyber_security: "Cyber Security",
//       teacher: "Teacher",
//       business_man: "Business Man",
//       armed_forces: "Armed Forces",
//       other: "Other",
//     },
//     religion: {
//       islam: "Islam",
//       christianity: "Christianity",
//       hinduism: "Hinduism",
//       buddhism: "Buddhism",
//       other_religion: "Other",
//     },
//     you_are: { self: "Self", parent_guardian: "Parent/Guardian" },
//   };

//   const handleChange = (e) => {
//     const { name, value, type, files } = e.target;

//     if (name === "image") {
//       const file = files[0];
//       if (file) {
//         const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
//         if (!allowedTypes.includes(file.type)) {
//           toast.error("Only PNG, JPEG, and JPG formats are allowed.");
//           return;
//         }
//         setFormData((prevData) => ({
//           ...prevData,
//           [name]: file,
//         }));
//       }
//       return;
//     }

//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: type === "number" ? Number(value) : value,
//     }));
//   };

//   const validateForm = () => {
//     const requiredFields = [
//       "first_name",
//       "last_name",
//       "email",
//       "whatsapp",
//       "occupation",
//       "show_name",
//       "income",
//       "gender",
//       "feet",
//       "inch",
//       "marital_status",
//       "caste",
//       "look",
//       "education",
//       "religion",
//       "mobile",
//       "you_are",
//       "world_country_id",
//       "world_division_id",
//       "world_city_id",
//       "dob",
//       "age",
//     ];

//     for (let field of requiredFields) {
//       if (!formData[field] || formData[field] === "") {
//         toast.error(`${field.replace("_", " ")} is required.`);
//         return false;
//       }
//     }

//     if (formData.password !== formData.password_confirmation) {
//       toast.error("Passwords do not match.");
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateForm()) return;

//     const formDataToSend = new FormData();

//     Object.keys(formData).forEach((key) => {
//       if (
//         formData[key] !== null &&
//         formData[key] !== undefined &&
//         formData[key] !== ""
//       ) {
//         formDataToSend.append(`user[${key}]`, formData[key]);
//       }
//     });

//     try {
//       const response = await baseURL.post(`/users`, formDataToSend, {
//         headers: { "Content-Type": "multipart/form-data" },
//       });
//       toast.success("Signup successful!");
//       navigate("/login");
//     } catch (error) {
//       console.error("Signup Error:", error.response.data.errors);
//       toast.error(
//         error.response?.data?.errors[0] || "Error signing up. Please try again."
//       );
//     }
//   };
//   useEffect(() => {
//     const fetchCountries = async () => {
//       try {
//         const response = await baseURL.get("/get_all_countries");
//         setCountries(response.data.countries);
//       } catch (error) {
//         console.error("Error fetching countries:", error);
//         toast.error("Failed to load countries.");
//       }
//     };

//     fetchCountries();
//   }, []);
//   const handleCountryChange = async (e) => {
//     const selectedCountry = e.target.value;
//     setFormData((prevData) => ({
//       ...prevData,
//       world_country_id: selectedCountry,
//       world_division_id: "",
//       world_city_id: "",
//     }));

//     try {
//       const response = await baseURL.get(
//         `/get_world_divisions/${selectedCountry}`
//       );
//       setDivisions(response.data.divisions);
//     } catch (error) {
//       console.error("Error fetching divisions:", error);
//       toast.error("Failed to load divisions.");
//     }
//   };
//   const handleDivisionChange = async (e) => {
//     const selectedDivision = e.target.value;
//     setFormData((prevData) => ({
//       ...prevData,
//       world_division_id: selectedDivision,
//       world_city_id: "",
//     }));

//     try {
//       const response = await baseURL.get(`/get_all_cities/${selectedDivision}`);
//       setCities(response.data.cities);
//     } catch (error) {
//       console.error("Error fetching cities:", error);
//       toast.error("Failed to load cities.");
//     }
//   };

//   return (
//     <>
//       <ToastContainer />
//       <p className="p-4 text-center font-serif">
//         Already have an account?{" "}
//         <Link to="/login">
//           <span className="text-[#730000] underline cursor-pointer hover:opacity-70">
//             Sign In
//           </span>
//         </Link>
//       </p>
//       <h2 className="text-3xl font-bold text-[#730000] text-center mb-2 font-serif">
//         Create an account
//       </h2>
//       <h3 className="text-center text-[#730000] text-lg font-semibold mb-6 font-serif">
//         Register for free and share your complete profile for matchmaking
//       </h3>
//       <div className="flex font-serif">
//         <div className="w-1/2 max-md:hidden relative flex  items-center justify-center">
//           <img
//             src={sideImage}
//             alt="Illustration"
//             className="rounded-lg object-fit w-full h-full pl-4"
//           />
//         </div>
//         <div className="w-1/2 max-md:w-full flex flex-col justify-center items-center bg-white px-2">
//           <form
//             onSubmit={handleSubmit}
//             className="bg-white border border-grey-300 rounded-lg p-4 w-full font-serif"
//           >
//             <h3 className="text-center text-lg font-semibold mb-6 font-serif">
//               Basic Information
//             </h3>
//             <div className="grid grid-cols-2 gap-2 font-serif">
//               {Object.keys(formData).map(
//                 (key) =>
//                   key !== "world_country_id" &&
//                   key !== "world_division_id" &&
//                   key !== "world_city_id" &&
//                   key !== "feet" &&
//                   key !== "inch" &&
//                   key !== "password" &&
//                   key !== "password_confirmation" && (
//                     <div key={key} className="mb-3">
//                       <label className="font-semibold text-[#730000]">
//                         {key.replace("_", " ").toUpperCase()}
//                       </label>
//                       {enumData[key] ? (
//                         <select
//                           name={key}
//                           value={formData[key]}
//                           onChange={handleChange}
//                           className="w-full p-2 border border-red-300 rounded-md"
//                         >
//                           <option value="">Select</option>
//                           {Object.entries(enumData[key]).map(
//                             ([value, label]) => (
//                               <option key={value} value={value}>
//                                 {label}
//                               </option>
//                             )
//                           )}
//                         </select>
//                       ) : (
//                         <input
//                           type={
//                             key === "dob"
//                               ? "date"
//                               : key === "image"
//                               ? "file"
//                               : [
//                                   "height",
//                                   "whatsapp",
//                                   "mobile",
//                                   "feet",
//                                   "inch",
//                                   "age",
//                                 ].includes(key)
//                               ? "number"
//                               : "text"
//                           }
//                           name={key}
//                           value={key === "image" ? undefined : formData[key]}
//                           onChange={handleChange}
//                           className="w-full p-2 border border-red-300 rounded-md"
//                           {...(key === "image" && {
//                             accept: "image/png, image/jpeg, image/jpg",
//                           })}
//                         />
//                       )}
//                     </div>
//                   )
//               )}
//               <div className="mb-3 font-serif">
//                 <div className="flex gap-2">
//                   <div className="flex-1">
//                     <label className="text-[#730000] font-semibold font-serif">
//                       Height (feet)
//                     </label>
//                     <input
//                       type="number"
//                       name="feet"
//                       value={formData.feet}
//                       onChange={handleChange}
//                       className="w-full p-2 border border-red-300 rounded-md"
//                       placeholder="Feet"
//                     />
//                   </div>
//                   <div className="flex-1 font-serif">
//                     <label className="text-[#730000] font-semibold font-serif">
//                       Height (inches)
//                     </label>
//                     <input
//                       type="number"
//                       name="inch"
//                       value={formData.inch}
//                       onChange={handleChange}
//                       className="w-full p-2 border border-red-300 rounded-md"
//                       placeholder="Inches"
//                     />
//                   </div>
//                 </div>
//               </div>

//               <div className="mb-3 font-serif">
//                 <label className="font-semibold text-[#730000]">Country</label>
//                 <select
//                   name="world_country_id"
//                   value={formData.world_country_id}
//                   onChange={handleCountryChange}
//                   className="w-full p-2 border border-red-300 rounded-md"
//                 >
//                   <option value="">Select Country</option>
//                   {Array.isArray(countries) && countries.length > 0 ? (
//                     countries.map((country) => (
//                       <option key={country.id} value={country.id}>
//                         {country.name}
//                       </option>
//                     ))
//                   ) : (
//                     <option disabled>No countries available</option>
//                   )}
//                 </select>
//               </div>

//               <div className="mb-3">
//                 <label className="font-semibold text-[#730000]">States</label>
//                 <select
//                   name="world_division_id"
//                   value={formData.world_division_id}
//                   onChange={handleDivisionChange}
//                   className="w-full p-2 border border-red-300 rounded-md"
//                   disabled={!formData.world_country_id}
//                 >
//                   <option value="">Select States</option>
//                   {divisions.map((division) => (
//                     <option key={division.id} value={division.id}>
//                       {division.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div className="mb-3">
//                 <label className="font-semibold text-[#730000]">City</label>
//                 <select
//                   name="world_city_id"
//                   value={formData.world_city_id}
//                   onChange={handleChange}
//                   className="w-full p-2 border border-red-300 rounded-md"
//                   disabled={!formData.world_division_id}
//                 >
//                   <option value="">Select City</option>
//                   {cities.map((city) => (
//                     <option key={city.id} value={city.id}>
//                       {city.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               <div>
//                 <label className="font-semibold text-[#730000]">Password</label>
//                 <input
//                   type="password"
//                   name="password"
//                   value={formData.password}
//                   onChange={handleChange}
//                   className="w-full p-2 border border-red-300 rounded-md"
//                 />
//               </div>
//               <div>
//                 <label className="font-semibold text-[#730000]">
//                   Confirm Password
//                 </label>
//                 <input
//                   type="password"
//                   name="password_confirmation"
//                   value={formData.password_confirmation}
//                   onChange={handleChange}
//                   className="w-full p-2 border border-red-300 rounded-md"
//                 />
//               </div>
//               <br />

//               <div className="mt-5">
//                 <button
//                   type="submit"
//                   className="bg-[#730000] text-white py-2 px-4 rounded-md font-semibold w-full"
//                 >
//                   Register
//                 </button>
//               </div>
//             </div>
//           </form>
//         </div>
//       </div>
//     </>
//   );
// };

// export default SignUpScreen;


import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import baseURL from "./baseURL/BaseURL";
import sideImage from "../../assets/images/signup.jpeg";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SignUpScreen = () => {
  const navigate = useNavigate();
  const [countries, setCountries] = useState([]);
  const [refferals, setRefferals] = useState([]);
  const [divisions, setDivisions] = useState([]);
  const [cities, setCities] = useState([]);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    gender: "",
    occupation: "",
    income: "",
    password: "",
    password_confirmation: "",
    title: "",
    description: "",
    show_name: "",
    feet: "",
    inch: "",
    marital_status: "",
    caste: "",
    refferal: "",
    look: "",
    education: "",
    religion: "",
    whatsapp: "",
    mobile: "",
    you_are: "",
    world_country_id: "",
    world_division_id: "",
    world_city_id: "",
    dob: "",
    age: "",
    image: null,
  });

  const enumData = {
    show_name: { show_yes: "Yes", show_no: "No" },
    gender: { male: "Male", female: "Female" },
    marital_status: {
      single: "Single",
      married: "Married",
      widow: "Widow (Husband Died)",
      widower: "Widower (Wife Died)",
      divorced: "Divorced",
      separated: "Separated",
    },
    look: {
      very_fair: "Very Fair",
      fair: "Fair",
      medium: "Medium",
      dark: "Dark",
    },
    education: {
      under_matric: "Under Matric",
      matric: "Matric",
      intermediate: "Intermediate",
      graduation: "Graduation",
      masters: "Masters",
      phd: "PHD",
    },
    occupation: {
      doctor: "Doctor",
      engineer: "Engineer",
      css_officer: "CSS Officer",
      cyber_security: "Cyber Security",
      teacher: "Teacher",
      business_man: "Business Man",
      armed_forces: "Armed Forces",
      other: "Other",
    },
    religion: {
      islam: "Islam",
      christianity: "Christianity",
      hinduism: "Hinduism",
      buddhism: "Buddhism",
      other_religion: "Other",
    },
    you_are: { self: "Self", parent_guardian: "Parent/Guardian" },
  };

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;

    if (name === "image") {
      const file = files[0];
      if (file) {
        const allowedTypes = ["image/png", "image/jpeg", "image/jpg"];
        if (!allowedTypes.includes(file.type)) {
          toast.error("Only PNG, JPEG, and JPG formats are allowed.");
          return;
        }
        setFormData((prevData) => ({
          ...prevData,
          [name]: file,
        }));
      }
      return;
    }

    // Calculate age automatically when DOB changes
    if (name === "dob") {
      const birthDate = new Date(value);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDiff = today.getMonth() - birthDate.getMonth();

      if (
        monthDiff < 0 ||
        (monthDiff === 0 && today.getDate() < birthDate.getDate())
      ) {
        age--;
      }

      setFormData((prevData) => ({
        ...prevData,
        [name]: value,
        age: age.toString(), // Update age field automatically
      }));
    } else if (name === "title") {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "number" ? Number(value) : value,
        description: value, // Set description to the same value as title
      }));
    }else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: type === "number" ? Number(value) : value,
      }));
    }
  };

  const validateForm = () => {
    const requiredFields = [
      "first_name",
      "last_name",
      "email",
      "whatsapp",
      "occupation",
      "show_name",
      "income",
      "gender",
      "title",
      "refferal",
      "feet",
      "inch",
      "marital_status",
      "caste",
      "look",
      "education",
      "religion",
      "mobile",
      "you_are",
      "world_country_id",
      "world_division_id",
      "world_city_id",
      "dob",
    ];

    for (let field of requiredFields) {
      if (!formData[field] || formData[field] === "") {
        toast.error(`${field.replace("_", " ")} is required.`);
        return false;
      }
    }

    if (formData.password !== formData.password_confirmation) {
      toast.error("Passwords do not match.");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formDataToSend = new FormData();

    Object.keys(formData).forEach((key) => {
      if (
        formData[key] !== null &&
        formData[key] !== undefined &&
        formData[key] !== ""
      ) {
        formDataToSend.append(`user[${key}]`, formData[key]);
      }
    });

    try {
      const response = await baseURL.post(`/users`, formDataToSend, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      console.log("payload>>>>", Array.from(formDataToSend.entries()));
      toast.success("Signup successful!");
      navigate("/login");
    } catch (error) {
      console.error("Signup Error:", error.response?.data?.errors);
      toast.error(
        error.response?.data?.errors[0] || "Error signing up. Please try again."
      );
    }
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await baseURL.get("/get_all_countries");
        setCountries(response.data.countries);
      } catch (error) {
        console.error("Error fetching countries:", error);
        toast.error("Failed to load countries.");
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    const fetchRefferals = async () => {
      try {
        const response = await baseURL.get("/refferals"); // Update to "/refferals" if needed
        setRefferals(response.data.refferals); // Adjust if response key is different
      } catch (error) {
        console.error("Error fetching refferals:", error);
        toast.error("Failed to load refferals.");
      }
    };

    fetchRefferals();
  }, []);

  const handleCountryChange = async (e) => {
    const selectedCountry = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      world_country_id: selectedCountry,
      world_division_id: "",
      world_city_id: "",
    }));

    try {
      const response = await baseURL.get(
        `/get_world_divisions/${selectedCountry}`
      );
      setDivisions(response.data.divisions);
    } catch (error) {
      console.error("Error fetching divisions:", error);
      toast.error("Failed to load divisions.");
    }
  };

  const handleDivisionChange = async (e) => {
    const selectedDivision = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      world_division_id: selectedDivision,
      world_city_id: "",
    }));

    try {
      const response = await baseURL.get(`/get_all_cities/${selectedDivision}`);
      setCities(response.data.cities);
    } catch (error) {
      console.error("Error fetching cities:", error);
      toast.error("Failed to load cities.");
    }
  };

  const renderField = (key) => {
    if (key === "title") {
      return (
        <div key={key} className="mb-3 col-span-2">
          <label className="font-semibold text-[#730000]">
            {key.replace("_", " ").toUpperCase()} 
            <font style={{fontSize: "10px"}}> (See example below)</font>
          </label>
          <textarea
            name={key}
            value={formData[key]}
            onChange={handleChange}
            className="w-full p-2 border border-red-300 rounded-md"
            rows="3"
            placeholder={
              "Must be detailed and extensive and inclusive of your details including your background / location and who you're seeking)"
            }
          />

          <label className="font-semibold text-[#730000]">EXAMPLE*</label>
          <textarea
            readOnly
            disabled
            className="w-full p-2 border border-red-300 rounded-md"
            rows="4"
            style={{resize: "none"}}
            placeholder={
              "I am 26 years old. I am an MBBS doctor and a successful businessman. I have completed my Bachelors and Masters from USA and currently residing in DHA Lahore with my parents. I am seeking a highly educated and pious girl from a moderately religious family within Lahore. We are also open to abroad proposals."
            }
          />
        </div>
      );
    }

    if (enumData[key]) {
      return (
        <div key={key} className="mb-3">
          <label className="font-semibold text-[#730000]">
            {
              key == "show_name" ? "show_name_on_platform".split("_").join(" ").toUpperCase() : key.replace("_", " ").toUpperCase()
            }
          </label>
          <select
            name={key}
            value={formData[key]}
            onChange={handleChange}
            className="w-full p-2 border border-red-300 rounded-md"
          >
            <option value="">Select</option>
            {Object.entries(enumData[key]).map(([value, label]) => (
              <option key={value} value={value}>
                {label}
              </option>
            ))}
          </select>
        </div>
      );
    }

    return (
      <div key={key} className="mb-3">
        <label className="font-semibold text-[#730000]">
          {key.replace("_", " ").toUpperCase()}
        </label>
        <input
          type={
            key === "dob"
              ? "date"
              : key === "image"
              ? "file"
              : ["height", "whatsapp", "mobile", "feet", "inch"].includes(key)
              ? "number"
              : "text"
          }
          name={key}
          value={key === "image" ? undefined : formData[key]}
          onChange={handleChange}
          className="w-full p-2 border border-red-300 rounded-md"
          {...(key === "image" && {
            accept: "image/png, image/jpeg, image/jpg",
          })}
        />
      </div>
    );
  };

  return (
    <>
      <ToastContainer />
      <p className="p-4 text-center font-serif">
        Already have an account?{" "}
        <Link to="/login">
          <span className="text-[#730000] underline cursor-pointer hover:opacity-70">
            Sign In
          </span>
        </Link>
      </p>
      <h2 className="text-3xl font-bold text-[#730000] text-center mb-2 font-serif">
        Create an account
      </h2>
      <h3 className="text-center text-[#730000] text-lg font-semibold mb-6 font-serif">
        Register for free and share your complete profile for matchmaking
      </h3>
      <div className="flex font-serif">
        <div className="w-1/2 max-md:hidden relative flex items-center justify-center">
          <img
            src={sideImage}
            alt="Illustration"
            className="rounded-lg object-fit w-full h-full pl-4"
          />
        </div>
        <div className="w-1/2 max-md:w-full flex flex-col justify-center items-center bg-white px-2">
          <form
            onSubmit={handleSubmit}
            className="bg-white border border-grey-300 rounded-lg p-4 w-full font-serif"
          >
            <h3 className="text-center text-lg font-semibold mb-6 font-serif">
              Basic Information
            </h3>
            <div className="grid grid-cols-2 gap-2 font-serif">
              {renderField("title")}
              {Object.keys(formData).map(
                (key) =>
                  key !== "world_country_id" &&
                  key !== "world_division_id" &&
                  key !== "world_city_id" &&
                  key !== "feet" &&
                  key !== "inch" &&
                  key !== "password" &&
                  key !== "age" &&
                  key !== "password_confirmation" &&
                  key !== "title" &&
                  key !== "description" && // Exclude description from rendering
                  key !== "refferal" &&
                  renderField(key)
              )}

              <div className="mb-3 font-serif">
                <div className="flex gap-2">
                  <div className="flex-1">
                    <label className="text-[#730000] font-semibold font-serif">
                      Height (feet)
                    </label>
                    <input
                      type="number"
                      name="feet"
                      value={formData.feet}
                      onChange={handleChange}
                      className="w-full p-2 border border-red-300 rounded-md"
                      placeholder="Feet"
                    />
                  </div>
                  <div className="flex-1 font-serif">
                    <label className="text-[#730000] font-semibold font-serif">
                      Height (inches)
                    </label>
                    <input
                      type="number"
                      name="inch"
                      value={formData.inch}
                      onChange={handleChange}
                      className="w-full p-2 border border-red-300 rounded-md"
                      placeholder="Inches"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3 font-serif">
                <label className="font-semibold text-[#730000]">Country</label>
                <select
                  name="world_country_id"
                  value={formData.world_country_id}
                  onChange={handleCountryChange}
                  className="w-full p-2 border border-red-300 rounded-md"
                >
                  <option value="">Select Country</option>
                  {Array.isArray(countries) && countries.length > 0 ? (
                    countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))
                  ) : (
                    <option disabled>No countries available backed</option>
                  )}
                </select>
              </div>

              <div className="mb-3">
                <label className="font-semibold text-[#730000]">States</label>
                <select
                  name="world_division_id"
                  value={formData.world_division_id}
                  onChange={handleDivisionChange}
                  className="w-full p-2 border border-red-300 rounded-md"
                  disabled={!formData.world_country_id}
                >
                  <option value="">Select States</option>
                  {divisions.map((division) => (
                    <option key={division.id} value={division.id}>
                      {division.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mb-3">
                <label className="font-semibold text-[#730000]">City</label>
                <select
                  name="world_city_id"
                  value={formData.world_city_id}
                  onChange={handleChange}
                  className="w-full p-2 border border-red-300 rounded-md"
                  disabled={!formData.world_division_id}
                >
                  <option value="">Select City</option>
                  {cities.map((city) => (
                    <option key={city.id} value={city.id}>
                      {city.name}
                    </option>
                  ))}
                </select>
              </div>

              <div>
                <label className="font-semibold text-[#730000]">Password</label>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full p-2 border border-red-300 rounded-md"
                />
              </div>
              <div>
                <label className="font-semibold text-[#730000]">
                  Confirm Password
                </label>
                <input
                  type="password"
                  name="password_confirmation"
                  value={formData.password_confirmation}
                  onChange={handleChange}
                  className="w-full p-2 border border-red-300 rounded-md"
                />
              </div>
              <br />

            </div>
            <div className="mt-5">
                <button
                  type="submit"
                  className="bg-[#730000] text-white py-2 px-4 rounded-md font-semibold w-full"
                >
                  Register
                </button>
              </div>
            <div key="refferal" className="mb-3 mt-5" style={{width: "50%"}}>
              <label className="font-semibold text-[#730000]">REFERRED BY</label>
              <select
                name="refferal"
                value={formData.refferal}
                onChange={handleChange}
                className="w-full p-2 border border-red-300 rounded-md"
              >
                <option value="None">None</option>
                {refferals.map((ref) => (
                  <option key={ref.id} value={ref.name}>
                    {ref.name}
                  </option>
                ))}
              </select>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default SignUpScreen;